import * as React from "react"

import { cn } from "@/lib/utils"

// V2 field (field.css): 36px control height, hairline-input border, 8px
// "menu" corners by default — `pill` opts into the full pill radius the
// single-line search idiom uses (mockup's filter-bar inputs).
function Input({
  className,
  type,
  pill = false,
  ...props
}: React.ComponentProps<"input"> & { pill?: boolean }) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-etn-text-placeholder selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-etn-border-input h-[var(--etn-control-height-input)] w-full min-w-0 border bg-etn-surface px-3.5 py-1 text-etn-control transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        pill ? "rounded-etn-pill" : "rounded-etn-menu",
        "focus-visible:border-etn-accent focus-visible:ring-0 focus-visible:shadow-[var(--etn-focus-glow)]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  )
}

export { Input }
